export enum TextTransform {
  None = 'none',
  Uppercase = 'uppercase'
}



// WEBPACK FOOTER //
// ./src/data/TextTransform.ts